import React from "react"

import { Action } from "shared/types/Action"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useTabBarContext } from "../context/TabBarContext"
import { TabBarBaseTab } from "./TabBarBaseTab"
import { TabBarSortableTab } from "./TabBarSortableTab"

export interface TabBarTabProps {
  eventKey: string
  index: number
  isDragDisabled?: boolean
  dragSourceData?: unknown
  label: string
  icon?: IconName
  count?: number
  truncationThreshold?: number
  className?: string
  disabled?: boolean
  variant?: "default" | "warning" | "error"
  "aria-controls"?: string
  "aria-label"?: string
  actions?: Action[]
}

export const TabBarTab = React.memo(
  React.forwardRef<HTMLDivElement, TabBarTabProps>((props, ref) => {
    const { enableSort } = useTabBarContext()
    if (enableSort) return <TabBarSortableTab ref={ref} {...props} />
    return <TabBarBaseTab ref={ref} {...props} />
  })
)

TabBarTab.displayName = "TabBar.Tab"
